import { checkKeycloakAdminRoles, getClientId, parseJwt } from 'shared/utils'

export const checkSuperAdminRole = () => {
    const token = localStorage.getItem('accessToken')
    const { resource_access } = parseJwt(token)
    const clientId = getClientId()
    const roles = resource_access?.[clientId]?.roles ?? []

    return checkKeycloakAdminRoles(roles)
}
